import { ApolloQueryResult } from '@apollo/client';
import { GetDonorQuery, GetDonorQueryVariables } from 'gql/types';
import { GET_DONOR_QUERY } from 'modules/donor/graphql/queries';
import { saveDonorToCache } from 'modules/donor/utils/donor-cache';
import { apolloClient } from 'providers/graphql';

export const getDonor = async (
  id: string
): Promise<ApolloQueryResult<GetDonorQuery>> => {
  const response = await apolloClient.query<
    GetDonorQuery,
    GetDonorQueryVariables
  >({
    query: GET_DONOR_QUERY,
    variables: {
      input: {
        id,
      },
    },
  });

  if (response.data?.getDonor) {
    saveDonorToCache(response.data.getDonor);
  }

  return response;
};
